import '../scss/style.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Controller, EffectFade, Scrollbar, Mousewheel, Grid} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';

document.addEventListener('DOMContentLoaded', function () {
    
    const modalSearch = document.querySelector('.modal-search');
    const openSearch = document.querySelector('.open-search');
    const modalInput = modalSearch.querySelector('input');
    const closeSearch = document.querySelectorAll('.close-search');

    openSearch.addEventListener('click', (e) => {
        e.preventDefault();

        modalSearch.classList.remove('hidden');
        modalSearch.classList.add('flex');

        requestAnimationFrame(() => {
            modalInput.focus();
        });
    });
    

    if (closeSearch && modalSearch) {
        closeSearch.forEach(cs => {
            cs.addEventListener('click', (e) => {
                e.preventDefault();

                modalSearch.classList.add('hidden');
                modalSearch.classList.remove('flex');
            });
        });
    }

    const openMobile = document.querySelector('.open-mobile');
    const mobileMenu = document.querySelector('.mobile-menu');
    
    openMobile.addEventListener('click', (e) => {
        e.preventDefault();
        
        const isOpen = mobileMenu.style.maxHeight === "100rem";

        mobileMenu.style.maxHeight = isOpen ? "0" : "100rem";
    });

    const items = document.querySelectorAll('.accordion-item');

    items.forEach(item => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        const icon = item.querySelector('.accordion-icon');

        header.addEventListener('click', () => {
            const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

            items.forEach(i => {
                i.querySelector('.accordion-content').style.maxHeight = null;
                i.querySelector('.accordion-icon').classList.remove('rotate-180');
            });

            if (!isOpen) {
                content.style.maxHeight = content.scrollHeight + "px";
                icon.classList.add('rotate-180');
            }
        });
    });


    const filterLinks = document.querySelectorAll('.filters a');
    const accordionItems = document.querySelectorAll('.accordion-item');

    filterLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const selectedFilter = link.textContent.trim();

            filterLinks.forEach(l => l.classList.remove('active'));

            link.classList.add('active');

            accordionItems.forEach(item => {
                const itemFilter = item.dataset.filter;
                if (itemFilter === selectedFilter) {
                    item.classList.remove('hidden');
                } else {
                    item.classList.add('hidden');
                }
            });
        });
    });

    var swiperText = new Swiper('.slider-mini', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination-mini',
            clickable: true,
        }
    });

    var swiperText = new Swiper('.slider-icons', {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
        },
        pagination: {
            el: '.swiper-pagination-icons',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: 1000
    });

    var swiperText = new Swiper('.slider-cards', {
        modules: [Navigation, Pagination],
        loop: true,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination-cards',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            960: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        }
    });

    var swiperText = new Swiper('.slider-logos-grid', {
        modules: [Pagination, Grid],
        slidesPerView: 2,
        grid: {
            rows: 2,
        },
        pagination: {
            el: '.swiper-pagination-slider-logos-grid',
            clickable: true,
        },
    });

    // Single copy to clipboard
    if(document.querySelector('.copy-to-clipboard')) {
        const copy = document.querySelector('.copy-to-clipboard');

        copy.addEventListener('click', (e) => {
            e.preventDefault();

            const currentUrl = window.location.href;
            navigator.clipboard.writeText(currentUrl)
                .then(() => {
                    const text = document.querySelector('.copied-success-text');
                    text.classList.add('active');

                    setTimeout(() => {
                        text.classList.remove('active');
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Error al copiar URL al portapapeles: ', error);
                });
        });
    }

    // Mobile submenus
    document.querySelectorAll('.mobile-submenu-trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const parentLi = trigger.closest('.parent-li');
            const submenu = parentLi.querySelector('.mobile-submenu');
            const isOpen = submenu.classList.contains('active');

            document.querySelectorAll('.parent-li').forEach(li => {
                li.querySelector('.mobile-submenu')?.classList.remove('active');
                li.querySelector('.mobile-submenu-trigger')?.classList.remove('active', 'rotate-180');
            });

            if (!isOpen) {
                submenu.classList.add('active');
                trigger.classList.add('active', 'rotate-180');
            }
        });
    });

    const wrappers = document.querySelectorAll('.radios-wrapper');
    if (wrappers.length < 2) return;
    const radiosGroups = Array.from(wrappers).map(w => w.querySelectorAll('input[type="radio"]'));
    const labelsGroups = Array.from(wrappers).map(w => w.querySelectorAll('label'));
    function syncRadios(index) {
        radiosGroups.forEach(radios => {
            radios.forEach((radio, i) => {
                radio.checked = (i === index);
            });
        });
        labelsGroups.forEach(labels => {
            labels.forEach((label, i) => {
                label.classList.toggle('active', i === index);
            });
        });
    }
    radiosGroups.forEach(radios => {
        radios.forEach((radio, i) => {
            radio.addEventListener('change', function () {
                if (radio.checked) syncRadios(i);
            });
        });
    });
    radiosGroups[0].forEach((radio, i) => {
        if (radio.checked) syncRadios(i);
    });
});